/**
 * Sticky filter bar that sits under the main header (top: 64px).
 * Four pills: Todas / Me faltan / Repetidas / Tengo, each with a live count.
 *
 * Pure presentational — state and counts come from the parent.
 * The optional layout toggle (grid ↔ list) is mobile-only via CSS.
 */
export default function GridFilterBar({ value, onChange, counts, layout, onLayoutChange }) {
  const filters = [
    { id: 'all',        label: 'Todas',     count: counts.all,        color: 'var(--text-primary)' },
    { id: 'missing',    label: 'Me faltan', count: counts.missing,    color: '#60a5fa' },
    { id: 'duplicates', label: 'Repetidas', count: counts.duplicates, color: '#4ade80' },
    { id: 'collected',  label: 'Tengo',     count: counts.collected,  color: 'var(--accent-gold)' },
  ];

  return (
    <div className="grid-filter-bar" role="tablist" aria-label="Filtrar láminas" data-tour="grid-filter">
      {filters.map(f => (
        <button
          key={f.id}
          role="tab"
          aria-selected={value === f.id}
          className={`grid-filter-pill ${value === f.id ? 'active' : ''}`}
          onClick={() => onChange(f.id)}
          style={value === f.id ? { borderColor: f.color, color: f.color } : undefined}
        >
          <span>{f.label}</span>
          <span className="grid-filter-count">{f.count}</span>
        </button>
      ))}
      {onLayoutChange && (
        <button
          className="grid-view-toggle"
          onClick={() => onLayoutChange(layout === 'list' ? 'grid' : 'list')}
          aria-label={layout === 'list' ? 'Ver como cuadrícula' : 'Ver como lista'}
          title={layout === 'list' ? 'Vista cuadrícula' : 'Vista lista'}
        >
          <span>{layout === 'list' ? '▦' : '☰'}</span>
          <span>{layout === 'list' ? 'Cuadrícula' : 'Lista'}</span>
        </button>
      )}
    </div>
  );
}
